<template>
  <div class="border rounded border-gray" :class="{'has-validation': errorMessage}" v-if="valueModel">
    <div class="w-100" :class="{'is-invalid': errorMessage}">
      <label class="form-label px-2 pt-2 text-muted">
        {{props.label}} <span v-if="props.subLabel" class="fst-italic">( {{ props.subLabel }} )</span> {{ props.required ? '*' : '' }}
      </label>
      <QuillyEditor
        class="border-0 pt-2"
        ref="editor"
        :is-semantic-html-model="true"
        v-model="valueModel.value"
        :options="options"
        :class="{'is-invalid': errorMessage}"
      />
      <div v-if="errorMessage" class="invalid-feedback d-block">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate';
import { computed, ref, onMounted } from 'vue';
import { QuillyEditor } from 'vue-quilly'
// import { ShortNameEmoji, ToolbarEmoji, TextAreaEmoji } from "@windmillcode/quill-emoji";
import Quill from 'quill'
import QuillResize from 'quill-resize-module';

const editor = ref<InstanceType<typeof QuillyEditor>>()
// eslint-disable-next-line @typescript-eslint/no-unused-vars
let quill: Quill | undefined
const options = {
  theme: 'snow',
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ size: [] }],
      ['blockquote'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      ['link', 'image'],
      ['clean']
    ],
    // "emoji-toolbar": true,
    // "emoji-textarea": true,
    // "emoji-shortname": true,
    resize: {
      modules: ['Resize', 'DisplaySize'],
      embedTags: ["VIDEO", "IFRAME"],
    }
  }
}

onMounted(() => {
  // Quill.register('modules/emoji-textarea', TextAreaEmoji,true)
  // Quill.register('modules/emoji-shortname', ShortNameEmoji,true)
  // Quill.register('modules/emoji-toolbar', ToolbarEmoji,true)
  Quill.register('modules/resize', QuillResize, true);
  quill = editor.value?.initialize(Quill)
})

const model = defineModel<string | null>({required: false});

const props = withDefaults(defineProps<{
  valueKey?: AllTypeKeys;
  label: string;
  subLabel?: string;
  placeholder?: string;
  required?: boolean;
  inputClass?: string;
}>(), {
  placeholder: '',
  required: false,
  inputClass: ''
});

const { value, errorMessage } = props.valueKey !== undefined ? useField<string>(() => props.valueKey!) : {};

const valueModel = computed(() => {
  if(props.valueKey) return value;
  else if(model.value !== undefined) return model;
  else return undefined;
})
</script>
